function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import BaseEvent from 'ol/events/Event';
import BaseObject from 'ol/Object';
import { randomFromCenter } from "@maplat/core/lib/math_ex";
import { toRadians } from 'ol/math';
var Property = {
  ACCURACY: 'accuracy',
  ACCURACY_GEOMETRY: 'accuracyGeometry',
  ALTITUDE: 'altitude',
  ALTITUDE_ACCURACY: 'altitudeAccuracy',
  HEADING: 'heading',
  POSITION: 'position',
  PROJECTION: 'projection',
  SPEED: 'speed',
  TRACKING: 'tracking',
  TRACKING_OPTIONS: 'trackingOptions'
};
var GeolocationErrorType = {
  ERROR: 'error'
};
export var GeolocationError = /*#__PURE__*/function (_BaseEvent) {
  _inherits(GeolocationError, _BaseEvent);
  var _super = _createSuper(GeolocationError);
  function GeolocationError(error) {
    var _this;
    _classCallCheck(this, GeolocationError);
    _this = _super.call(this, GeolocationErrorType.ERROR);
    _this.code = error.code;
    _this.message = error.message;
    return _this;
  }
  return _createClass(GeolocationError);
}(BaseEvent);
export var Geolocation = /*#__PURE__*/function (_BaseObject) {
  _inherits(Geolocation, _BaseObject);
  var _super2 = _createSuper(Geolocation);
  function Geolocation(options) {
    var _this2;
    _classCallCheck(this, Geolocation);
    _this2 = _super2.call(this);
    _defineProperty(_assertThisInitialized(_this2), "task_id_", null);
    _defineProperty(_assertThisInitialized(_this2), "timer_base_", false);
    _this2.on;
    _this2.once;
    _this2.un;
    options = options || {};
    _this2.timer_base_ = options.timerBase !== undefined ? options.timerBase : false;
    _this2.task_id_ = undefined;
    _this2.home_position_ = options.homePosition !== undefined ? options.homePosition : false;
    _this2.addChangeListener(Property.TRACKING, _this2.handleTrackingChanged_);
    if (options.trackingOptions !== undefined) {
      _this2.setTrackingOptions(options.trackingOptions);
    } else {
      _this2.setTrackingOptions({
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 1000
      });
    }
    _this2.setTracking(options.tracking !== undefined ? options.tracking : false);
    return _this2;
  }
  _createClass(Geolocation, [{
    key: "disposeInternal",
    value: function disposeInternal() {
      this.setTracking(false);
      _get(_getPrototypeOf(Geolocation.prototype), "disposeInternal", this).call(this);
    }
  }, {
    key: "handleTrackingChanged_",
    value: function handleTrackingChanged_() {
      if (this.timer_base_) {
        var tracking = this.getTracking();
        var trackingOptions = this.getTrackingOptions();
        if (tracking && this.task_id_ === undefined) {
          var allowGps = window.confirm("Allow GPS?");
          if (allowGps) {
            this.task_id_ = setInterval(this.timerPositionChange_.bind(this), trackingOptions.maximumAge);
          } else {
            setTimeout(this.timerPositionError_.bind(this), trackingOptions.maximumAge * 10);
          }
        } else if (!tracking && this.task_id_ !== undefined) {
          clearInterval(this.task_id_);
          this.task_id_ = undefined;
        }
      } else {
        if ('geolocation' in navigator) {
          var _tracking = this.getTracking();
          if (_tracking && this.task_id_ === undefined) {
            this.task_id_ = navigator.geolocation.watchPosition(this.positionChange_.bind(this), this.positionError_.bind(this), this.getTrackingOptions());
          } else if (!_tracking && this.task_id_ !== undefined) {
            navigator.geolocation.clearWatch(this.task_id_);
            this.task_id_ = undefined;
          }
        }
      }
    }
  }, {
    key: "timerPositionChange_",
    value: function timerPositionChange_() {
      var coords = {
        longitude: randomFromCenter(this.home_position_[0], 0.05),
        latitude: randomFromCenter(this.home_position_[1], 0.05),
        accuracy: randomFromCenter(15.0, 10)
      };
      this.positionChange_({
        coords: coords
      });
    }
  }, {
    key: "positionChange_",
    value: function positionChange_(position) {
      var coords = position.coords;
      this.set(Property.ACCURACY, coords.accuracy);
      this.set(Property.ALTITUDE, coords.altitude === null ? undefined : coords.altitude);
      this.set(Property.ALTITUDE_ACCURACY, coords.altitudeAccuracy === null ? undefined : coords.altitudeAccuracy);
      this.set(Property.HEADING, coords.heading === null ? undefined : toRadians(coords.heading));
      this.set(Property.POSITION, [coords.longitude, coords.latitude]);
      this.set(Property.SPEED, coords.speed === null ? undefined : coords.speed);
      this.changed();
    }
  }, {
    key: "timerPositionError_",
    value: function timerPositionError_() {
      var code = Math.floor(Math.random() * 3) + 1;
      var error = {
        code: code,
        message: code === 1 ? "User denied Geolocation" : code === 2 ? "Position unavailable" : "Timeout expired"
      };
      this.positionError_(error);
    }
  }, {
    key: "positionError_",
    value: function positionError_(error) {
      var desc = new GeolocationError(error);
      this.dispatchEvent(desc);
    }
  }, {
    key: "getAccuracy",
    value: function getAccuracy() {
      return this.get(Property.ACCURACY);
    }
  }, {
    key: "getAltitude",
    value: function getAltitude() {
      return this.get(Property.ALTITUDE);
    }
  }, {
    key: "getAltitudeAccuracy",
    value: function getAltitudeAccuracy() {
      return this.get(Property.ALTITUDE_ACCURACY);
    }
  }, {
    key: "getHeading",
    value: function getHeading() {
      return this.get(Property.HEADING);
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      return this.get(Property.POSITION);
    }
  }, {
    key: "getSpeed",
    value: function getSpeed() {
      return this.get(Property.SPEED);
    }
  }, {
    key: "getTracking",
    value: function getTracking() {
      return this.get(Property.TRACKING);
    }
  }, {
    key: "getTrackingOptions",
    value: function getTrackingOptions() {
      return this.get(Property.TRACKING_OPTIONS);
    }
  }, {
    key: "setTracking",
    value: function setTracking(tracking) {
      this.set(Property.TRACKING, tracking);
    }
  }, {
    key: "setTrackingOptions",
    value: function setTrackingOptions(options) {
      this.set(Property.TRACKING_OPTIONS, options);
    }
  }]);
  return Geolocation;
}(BaseObject);
;